var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.72439C10 0.324645 9.67534 0 9.27561 0H0.724389C0.324644 0 0 0.324656 0 0.72439V9.27518C0 9.67536 0.324656 10 0.724389 10H9.27517C9.67534 10 9.99999 9.67535 9.99999 9.27561L10 0.72439ZM8.04556 7.55551H2.21222C2.0525 7.55551 1.99738 7.41315 2.08939 7.28294L3.77517 4.86972C3.86675 4.73951 4.03384 4.71607 4.1467 4.82935L4.48741 5.16746C4.59982 5.28074 4.77473 5.27033 4.8763 5.14707L5.69444 4.15357C5.79557 4.03074 5.95269 4.03682 6.04383 4.1679L8.17106 7.28124C8.26133 7.41275 8.20491 7.55555 8.04562 7.55555L8.04556 7.55551ZM7.63757 4.62239C7.25214 4.62239 6.94009 4.30989 6.94009 3.92492C6.94009 3.53949 7.25216 3.22744 7.63757 3.22744C8.02298 3.22744 8.33504 3.53994 8.33504 3.92492C8.33548 4.30989 8.02298 4.62239 7.63757 4.62239Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/img_icon.fc057fe65eb21215c1ac44007d890042.svg";
export { ForwardRef as ReactComponent };